jQuery(document).foundation();

// sal();

function customSalScrollAnimationHandler() { // uses sal css but all js is custom due to https://github.com/mciastek/sal/issues/62
    const theSals = document.querySelectorAll('[data-sal]');
    if (theSals.length) {
        if (window.innerHeight > window.innerWidth) {
            console.log('portrait');
            var thePercent = 1 - 0.1;
        } else {
            var thePercent = 1 - 0.3;
        }
        [].forEach.call(theSals, function (e) {
            const salPos = e.getBoundingClientRect().top;
            const percentOfWindowHeight = window.innerHeight * thePercent; // using 70% of viewport height from the top (30% from the bottom)
            if (salPos < percentOfWindowHeight) { // if my element has been scrolled in at least 30% of the viewport height from the bottom
                e.classList.add('sal-animate');
            }
        });
    }
};
window.addEventListener('DOMContentLoaded', function () {
    customSalScrollAnimationHandler();
});
window.addEventListener('scroll', function () {
    customSalScrollAnimationHandler();
});


sal({
    threshold: 0.3,
    once: false,
  });